<template>
  <eve-regulatory-thresholds
    :data="activeEveAnalysis"
    :title="$t('Dashboard.Banking.InterestRateRisk.RegulatoryThresholds.Title')"
    dashboard-view
    title-icon="grey"
    title-icon-size="5"
  />
</template>

<script>
import { API } from '@/api/Api'
import RiskActiveEveAnalysisResource    from '@/api/resources/risks/RiskActiveEveAnalysisResource'
import EveRegulatoryThresholds from '@/theme/default/views/banking/risk/interest-rate/EVE/RegulatoryThresholds.vue'
import { clone } from '@/lib/utils/helper'

export default {
  name      : 'RegulatoryThresholds',
  components: { EveRegulatoryThresholds },
  dataStore : {
    ActiveEveAnalysis: 'RiskInterestRate.ActiveEveAnalysis'
  },
  data () {
    return {

    }
  },
  computed: {
    accountId () {
      return this.user?.selectedAccountId || null
    },
    // Get data from the dataStore (same as Rates.vue)
    activeEveAnalysis () {
      return this.ActiveEveAnalysis.Data || null
    }
  },

  created () {
    this.activeEveAnalysisData()
  },
  activated () {},
  mounted () {},
  beforeDestroy () {},
  methods: {
    async activeEveAnalysisData () {
      const response = await API.Resource.RiskInterestRate.ActiveEveAnalysis(this.accountId)
      this.handleResponse(response, 'activeEveAnalysis')
    },

    handleResponse (response, key) {
      const data = API.responseData(response)?.[key] || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        const o = clone(data)
        this.$set(this.ActiveEveAnalysis, 'Data', RiskActiveEveAnalysisResource.fromApiResponse(o))
      } else {
        this.$bus.$emit('app:error', errors)
      }
    }
  }

}

</script>
